module.exports = __webpack_public_path__ + "img/merlin prismriver_sc2.2983c23a.png";